import { LightningBoltIcon } from "@heroicons/react/outline";
import { Tooltip } from "../../components";

export const AutoEstimateIndicator = () => (
  <Tooltip
    trigger={<LightningBoltIcon className="w-4 h-4 text-gray-500" />}
    content={<>Bill Auto-estimated</>}
  />
);
